import { type ConversationAssistantConfig } from '../../../types';

import { type ProductKey } from './types';

export const serviceProductToProductKey = (
	product: ConversationAssistantConfig['product'],
): ProductKey => {
	switch (product) {
		case 'confluence':
			return 'confluence';
		case 'jira-software':
		case 'jira-core':
		case 'jsm':
		case 'jpd':
		case 'jira':
			return 'jira';
		case 'atlassian-studio':
		case 'rovo':
		case 'atlas':
			return 'atlas';
		case 'bitbucket':
			return 'bitbucket';
		case 'trello':
			return 'trello';
		case 'admin':
			return 'admin';
		case 'store':
			return 'store';
		default:
			return 'unknown';
	}
};
